var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6393 23.1091H21.1083L19.0658 25.087C18.129 25.9942 18.129 27.4828 19.0658 28.39C19.5418 28.8508 20.1601 29.0504 20.7471 29.0504C21.3181 29.0504 21.9347 28.8477 22.4074 28.39L28.5548 22.4573C29.0334 22.0194 29.2768 21.4074 29.2768 20.787C29.2768 20.1815 29.0296 19.5717 28.5548 19.1372L22.4074 13.2045C22.4073 13.2044 22.4072 13.2043 22.4071 13.2042C21.4838 12.3104 19.9891 12.3105 19.0658 13.2045C18.129 14.1117 18.129 15.6003 19.0658 16.5075L19.0675 16.5091L21.0999 18.4649H10.6388L10.6393 9.45582V9.45578C10.6393 4.89043 14.4973 1.12036 19.2713 1.12036H29.5599C34.3106 1.12036 38.1497 4.88827 38.1497 9.43536V32.1387C38.1497 36.703 34.314 40.4537 29.5177 40.4537H19.2502C14.495 40.4537 10.6393 36.7019 10.6393 32.1591V23.1091ZM9.13918 19.9647L9.13886 21.6089H1.70363C1.23061 21.6089 0.858063 21.2338 0.858063 20.7868C0.858063 20.354 1.23701 19.9647 1.70363 19.9647H9.13918Z",
    stroke: "#CE1111",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIn);
export default __webpack_public_path__ + "static/media/login_in.ae12bca7865d1984ac64e971f9b0f77d.svg";
export { ForwardRef as ReactComponent };